/** Color definition, split into four numeric components. Default color is a dark shade of grey (50, 50, 50, 255). */
export interface Color {
  /** The red component */
  readonly red: number;
  /** The green component */
  readonly green: number;
  /** The blue component */
  readonly blue: number;
  /** The alpha component */
  readonly alpha: number;
}

// Constants
export const DEFAULT_COLOR: Color = {
  red: 50,
  green: 50,
  blue: 50,
  alpha: 255,
};

// utility function for quickly defining colors
export const toColor: (red: number, green: number, blue: number, alpha: number) => Color =
  (red, green, blue, alpha) => ({ red, green, blue, alpha });

// converter function for color picker
export function convertToAntdColor(color: Color): string {
  return `rgba(${color.red}, ${color.green}, ${color.blue}, ${color.alpha / 255})`;
}

// utility function to convert a color to a string representation
export const stringifyColor = (color: Color): string => {
  return [color.red, color.green, color.blue, color.alpha].join(", ");
};
